// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchButton_switch__VyyOU","clickableArea":"SwitchButton_clickableArea__2wJAA","circle":"SwitchButton_circle__8ivWc","selected":"SwitchButton_selected__3fzjP"};